module.exports = __webpack_public_path__ + "img/sld_scb_35_t1_b1_green.5a27677e.svg";